import { useMemo } from 'react';
import { api } from '@/redux/api';
import { ApplicationUser } from '@/types/application-user';
import { findById } from '@/utils/find-by-id';
import { updateUserWithOrganisation } from '@/utils/update-user-with-organisation';
import { useCurrentOrganisation } from './use-current-organisation';
import { useOrganisations } from './use-organisations';
import { useUserRole } from './use-user-role';

export const useUsers = () => {
  const { isPlatformAdmin, isOrgAdmin } = useUserRole();
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();
  const { data: organisations } = useOrganisations();

  const result = api.useGetUsersQuery(undefined, {
    skip: !isPlatformAdmin && !isOrgAdmin, // TODO add a permissions hook
  });

  const data = useMemo(() => {
    let data: ApplicationUser[] = result.data ?? [];

    if (isPlatformAdmin) {
      data = data.map((user) =>
        updateUserWithOrganisation(
          user,
          findById(organisations, user.organisation?.id ?? -1),
        ),
      );
    }

    if (isUsingOrganisationOverride) {
      data = data.filter(
        (user: ApplicationUser) => user.organisation?.id === organisation?.id,
      );
    }

    return data;
  }, [
    isPlatformAdmin,
    isUsingOrganisationOverride,
    organisations,
    organisation?.id,
    result.data,
  ]);

  return { ...result, data };
};
